import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=2822df4e&scoped=true&"
import script from "./recordDetail.vue?vue&type=script&lang=js&"
export * from "./recordDetail.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./recordDetail.vue?vue&type=style&index=1&id=2822df4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822df4e",
  null
  
)

export default component.exports